<!-- <app-pagetitle title="{{'Danh sách cửa hàng' | translate}}" [breadcrumbItems]="breadCrumbItems"></app-pagetitle> -->

<div class="card">
    <div class="card-body">
        <h5>{{ "DANH SÁCH GIAO DỊCH GIA HẠN" | translate }}</h5>
        <div class="row mb-3">
            <div class="col-6 col-lg-3" *ngIf="chartOptions?.series">
                <div class="card mb-0 h-100">
                    <div class="card-header py-2">
                        <strong>Thống kê loại gia hạn</strong>
                    </div>
                    <div class="card-body d-flex flex-column justify-content-center align-items-center p-2">
                        <div class="d-flex justify-content-center w-100">
                            <apx-chart
                                [series]="chartOptions.series"
                                [chart]="chartOptions.chart"
                                [labels]="chartOptions.labels"
                                [colors]="chartOptions.colors"
                                [legend]="chartOptions.legend"
                                [dataLabels]="chartOptions.dataLabels"
                                [tooltip]="chartOptions.tooltip">
                            </apx-chart>
                        </div>
                        <div class="mt-1 text-center">
                            <strong>Tổng: {{ totalRenewCountFormatted }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6 col-lg-3" *ngIf="amountChartOptions?.series">
                <div class="card mb-0 h-100">
                    <div class="card-header py-2">
                        <strong>Thống kê số tiền gia hạn</strong>
                    </div>
                    <div class="card-body d-flex flex-column justify-content-center align-items-center p-2">
                        <div class="d-flex justify-content-center w-100">
                            <apx-chart
                                [series]="amountChartOptions.series"
                                [chart]="amountChartOptions.chart"
                                [labels]="amountChartOptions.labels"
                                [colors]="amountChartOptions.colors"
                                [legend]="amountChartOptions.legend"
                                [dataLabels]="amountChartOptions.dataLabels"
                                [plotOptions]="amountChartOptions.plotOptions"
                                [tooltip]="amountChartOptions.tooltip">
                            </apx-chart>
                        </div>
                        <div class="mt-1 text-center">
                            <strong>Tổng tiền: {{ totalRenewAmountFormatted }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Filters -->
            <div class="col-12 col-lg-6 mt-3 mt-lg-0">
                <div class="row">
                    <div class="col-6 col-md-4">
                        <div class="form-group">
                            <label>{{ "Số điện thoại" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.phone"
                                placeholder="{{ 'Nhập số điện thoại' | translate }}" />
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div class="form-group">
                            <label>{{ "Số tài khoản" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.terminal_bank_acc"
                                placeholder="{{ 'Nhập số tài khoản' | translate }}" />
                        </div>
                    </div>
                    <div class="form-group col-6 col-md-4">
                        <label>{{ "Loại gia hạn" | translate }}</label>
                        <ng-select [(ngModel)]="filter.renew_type" (change)="submitFilter()">
                            <ng-option value="">Tất cả</ng-option>
                            <ng-option value="Manual">Thủ công</ng-option>
                            <ng-option value="AutoDebit">Tự động</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-6 col-md-4">
                        <div class="form-group">
                            <label>{{ "Mã thiết bị" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.serial_number"
                                placeholder="{{ 'Nhập mã thiết bị' | translate }}" />
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div class="form-group">
                            <label>{{ "Mã giao dịch" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.mb_reference_number"
                                placeholder="{{ 'Nhập mã giao dịch' | translate }}" />
                        </div>
                    </div>
                    <div class="col-6 col-md-4">
                        <div class="form-group">
                            <label>{{ "Mã hoá đơn gốc" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="filter.invoice_no"
                                placeholder="{{ 'Nhập mã hoá đơn gốc' | translate }}" />
                        </div>
                    </div>
                    <div class="form-group col-6 col-md-4">
                        <label>{{ "Trạng thái xuất HĐ gốc" | translate }}</label>
                        <ng-select [(ngModel)]="filter.invoice_status" [clearable]="true" (change)="submitFilter()">
                            <ng-option value="">Tất cả</ng-option>
                            <ng-option value="created">Đã xuất</ng-option>
                            <ng-option value="not_created">Chưa xuất</ng-option>
                            <ng-option value="error">Xuất lỗi</ng-option>
                        </ng-select>
                    </div>
                    <div class="form-group col-6 col-md-4">
                        <mat-form-field appearance="fill" class="mt-3 w-100">
                            <mat-label>Chọn khoảng ngày gia hạn</mat-label>
                            <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                                <input matStartDate formControlName="start" placeholder="Ngày bắt đầu" />
                                <input matEndDate formControlName="end" placeholder="Ngày kết thúc" />
                            </mat-date-range-input>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                            <mat-error *ngIf="range.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                            <mat-error *ngIf="range.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 text-center mt-2">
                        <button class="btn btn-primary" (click)="submitFilter()">
                            {{ "PAGE.REPORT.Search" | translate }}
                        </button>
                        <button class="btn btn-dark ml-2" *ngIf="searching" (click)="clearFilter()">
                            {{ "FORM.Clear" | translate }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-md-2"></div>
        <div class="table-responsive">
            <table id="basic-datatable" class="table table-bordered dt-responsive nowrap no-footer dtr-inline">
                <thead>
                    <tr class="text-center bg-table">
                        <th>{{ "#" | translate }}</th>
                        <th>{{ "Thao tác" | translate }}</th>
                        <th>{{ "Mã cửa hàng" | translate }}</th>
                        <th>{{ "Mã thiết bị" | translate }}</th>
                        <th>{{ "Thông tin khách hàng" | translate }}</th>
                        <th>{{ "Thông tin tài khoản" | translate }}</th>
                        <th>{{ "Thông tin giao dịch" | translate }}</th>
                        <th>{{ "Thông tin gia hạn" | translate }}</th>
                        <th>{{ "Hoá đơn gốc" | translate }}</th>
                        <th>{{ "Nội dung claim" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of listData; let i = index">
                        <td class="text-center">
                            <a>{{ pageSize * (pageIndex - 1) + i + 1 }}</a>
                        </td>
                        <td class="text-center">
                            <div class="action-icons">
                                <span class="action-icon-slot">
                                    <a class="text-primary" style="cursor: pointer;"
                                       ngbTooltip="{{ 'Xem chi tiết' | translate }}" placement="top"
                                       (click)="viewDetail(data)">
                                        <i class="mdi mdi-eye-outline font-size-18"></i>
                                    </a>
                                </span>
                                <span class="action-icon-slot">
                                    <a class="text-danger" style="cursor: pointer;"
                                       *ngIf="canCreateClaim(data) && (role == 'admin' || role == 'customer service')"
                                       ngbTooltip="{{ 'Ghi nhận claim đơn gia hạn' | translate }}" placement="top"
                                       (click)="openClaimModal(data, contentClaim)">
                                        <i class="mdi mdi-flag-outline font-size-18"></i>
                                    </a>
                                </span>
                            </div>
                        </td>
                        <td>{{ data.workspace_code || '-' }}</td>
                        <td>{{ data.serial_number || '-' }}</td>
                        <td>
                            <div>{{ data.phone }}</div>
                            <div>{{ data.full_name }}</div>
                        </td>
                        <td>
                            <div>{{ data.terminal_bank_acc }}</div>
                            <div>{{ data.terminal_bank_acc_name }}</div>
                        </td>
                        <td>
                            <div>
                                <span class="badge" [ngClass]="data.discounted_price >= 395000 ? 'badge-warning' : 'badge-success'">
                                    {{ data.discounted_price.toLocaleString('vi-VN') }}
                                </span>
                            </div>
                            <div>{{ data.mb_reference_number || '-' }}</div>
                        </td>
                        <td>
                            <div>
                                <span class="badge" [ngClass]="data.renew_type === 'AutoDebit' ? 'badge-success' : 'badge-secondary'">
                                    {{ data.renew_type === 'AutoDebit' ? 'Tự động' : 'Thủ công' }}
                                </span>
                            </div>
                            <div>{{ data.created_at | date : "dd/MM/yyyy HH:mm" }}</div>
                        </td>
                        <td>
                            <ng-container *ngIf="data.invoice_no; else noInvoice">
                                <div>
                                    <a class="text-primary"
                                       style="cursor: pointer; text-decoration: underline;"
                                       (click)="previewInvoice(data.invoice_no, invoicePreviewModal)">
                                        {{ data.invoice_no }}
                                    </a>
                                </div>
                                <div>{{ data.invoice_date | date : "dd/MM/yyyy HH:mm" }}</div>
                            </ng-container>
                            <ng-template #noInvoice>
                                <ng-container *ngIf="data.invoice_err_message; else emptyInvoice">
                                    <i class="ri-close-circle-fill text-danger font-size-18"
                                       style="cursor: default;"
                                       ngbTooltip="{{ data.invoice_err_message }}"
                                       placement="top"></i>
                                </ng-container>
                                <ng-template #emptyInvoice>-</ng-template>
                            </ng-template>
                        </td>
                        <td>
                            <ng-container *ngIf="data.order_claim_id; else noClaim">
                                <div>{{ data.claim_reason }}</div>
                                <div>{{ data.claim_date | date : "dd/MM/yyyy" }}</div>
                            </ng-container>
                            <ng-template #noClaim>-</ng-template>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row justify-content-md-between align-items-md-center mt-2">
            <div class="col-sm-12 col-md-5">
                <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite">
                    {{ "TABLE.Showing" | translate }}
                    {{ pageSize * pageIndex - pageSize + 1 }}
                    {{ "TABLE.to" | translate }} {{ pageSize * pageIndex }}
                    {{ "TABLE.of" | translate }} {{ totalCount }}
                    {{ "TABLE.entries" | translate }}
                </div>
            </div>
            <!-- Pagination -->
            <div class="col-sm-12 col-md-5 d-flex align-items-center justify-content-end">
                <div class="text-md-right float-md-right pagination-rounded">
                    <ngb-pagination [collectionSize]="totalCount" [(page)]="pageIndex" [pageSize]="pageSize"
                        [maxSize]="5" [ellipses]="true" (pageChange)="fetchData()">
                    </ngb-pagination>
                </div>
                <div class="dataTables_length ml-3" id="tickets-table_length">
                    <label class="d-inline-flex align-items-center mb-0">
                        {{ "TABLE.Show" | translate }}
                        <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                            [(ngModel)]="pageSize" (ngModelChange)="pageIndex = 1; fetchData()"
                            class="custom-select custom-select-sm form-control form-control-sm mx-2">
                            <option [ngValue]="10">10</option>
                            <option [ngValue]="25">25</option>
                            <option [ngValue]="50">50</option>
                            <option [ngValue]="100">100</option>
                        </select>
                        {{ "TABLE.entries" | translate }}
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #contentClaim role="document" let-modal="close">
    <div class="modal-header">
        <h5 class="modal-title">{{ "GHI NHẬN CLAIM ĐƠN GIA HẠN" | translate }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-3">
        <div class="text-left">
            <form [formGroup]="formClaim" (ngSubmit)="submitClaim()">
                <div class="form-group row col-md-12">
                    <label class="col-md-12 col-form-label required_label">{{ "Ngày claim" | translate }}</label>
                    <div class="col-md-12">
                        <mat-form-field appearance="fill" class="w-100 mt-2">
                            <mat-label>{{ "Chọn ngày claim" | translate }}</mat-label>
                            <input
                                matInput
                                [matDatepicker]="pickerClaim"
                                formControlName="claimDate"
                                placeholder="{{ 'Ngày claim' | translate }}"
                            />
                            <mat-datepicker-toggle matSuffix [for]="pickerClaim"></mat-datepicker-toggle>
                            <mat-datepicker #pickerClaim></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="form-group row col-md-12">
                    <label class="col-md-12 col-form-label required_label">
                        {{ "Lý do claim" | translate }}
                    </label>
                    <div class="col-md-12">
                        <textarea
                            formControlName="claimReason"
                            class="form-control"
                            rows="4"
                            [ngClass]="{ 'is-invalid': submittedClaim && formClaim.get('claimReason').errors }"
                            placeholder="{{ 'Nhập lý do claim' | translate }}"
                        ></textarea>
                    </div>
                </div>
                <div class="text-center">
                    <button type="button" class="btn btn-secondary btn-lg mr-3" style="width: 150px"
                        (click)="modal('close click')">
                        {{ "Đóng" | translate }}
                    </button>
                    <button
                        [disabled]="
                            !formClaim.get('claimDate')?.value ||
                            !formClaim.get('claimReason')?.value?.trim()
                        "
                        type="submit" class="btn btn-success btn-lg" style="width: 150px">
                        {{ "Xác nhận" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-template>

<ng-template #invoicePreviewModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Hoá đơn: {{ previewInvoiceNo }}</h5>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body p-0" style="height: 80vh;">
        <iframe *ngIf="invoicePdfUrl"
            [src]="invoicePdfUrl"
            width="100%"
            height="100%"
            style="border: none;">
        </iframe>
    </div>
</ng-template>